import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { tap } from 'rxjs/internal/operators/tap';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { InvoiceService } from '../../Services/invoice.service';

@Component({
  selector: 'app-court-fees-audit-report',
  templateUrl: './court-fees-audit-report.component.html',
  styleUrls: ['./court-fees-audit-report.component.less']
})
export class CourtFeesAuditReportComponent implements OnInit {
  processing: boolean = false;

  constructor(public modalRef: NgbModal, private invoices: InvoiceService, private fileDownload: FileDownloadService, private toast: ToastrService) { }

  ngOnInit(): void {
  }

  cancel(): void {
    this.modalRef.dismissAll();
  }

  download(): void {
    this.processing = true;
    this.invoices.downloadCourtFeesCSV().pipe(
      tap((res: Blob) => {
        this.fileDownload.HandleFileDownload(res, 'text/csv', 'CourtReportFees.csv');
        this.toast.success('Report downloaded!');
        this.cancel();
      }, 
      () => {
        this.toast.error('There was an error downloading the report. Please contact support.');
      },
      () => {
        this.processing = false;
      })
    ).subscribe();
  }

}
